import { assistantOwnerId, isAssistantId } from "@worktools/shared";
import { useBoard } from "../sync/BoardContext";
import { useAwarenessStates, type BlockFrame } from "../sync/hooks";

/** Draws a coloured ring around every block another participant has selected. */
export function RemoteSelections({ frames }: { frames: BlockFrame[] }) {
  const states = useAwarenessStates();
  const { me } = useBoard();

  const labelFor = (user: { id: string; name: string; ownerName?: string }) => {
    if (!isAssistantId(user.id)) return user.name;
    return assistantOwnerId(user.id) === me.id ? "Dein Claude" : `Claude · ${user.ownerName ?? "?"}`;
  };

  return (
    <>
      {states.flatMap((state) =>
        state.selection.map((blockId) => {
          const frame = frames.find((item) => item.id === blockId);
          if (!frame) return null;
          return (
            <div
              key={`${state.clientId}-${blockId}`}
              className="remote-ring"
              style={{
                left: frame.x - 3,
                top: frame.y - 3,
                width: frame.w + 6,
                height: frame.h + 6,
                zIndex: frame.z,
                boxShadow: `0 0 0 2px ${state.user.color}`,
              }}
            >
              <div className="remote-ring__tag" style={{ background: state.user.color }}>
                {labelFor(state.user as never)}
              </div>
            </div>
          );
        }),
      )}
    </>
  );
}
